const Footer = ({ className }) => (
  <footer className={className}>
    Designed and Developed by{' '}
    <a
      href="https://leighbuendia.netlify.app"
      target="_blank"
      rel="noreferrer"
    >
      Leigh Arriane Buendia
    </a>
  </footer>
);

export default Footer;
